import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-pardeep',
  templateUrl: './pardeep.component.html',
  styleUrls: ['./pardeep.component.scss']
})
export class PardeepComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getPradeep();
  }

}
